import styled from 'styled-components';

export const IsFetchingObsDataContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    opacity: 0.3;
    width: 100%;
    height: 100%;
`;
